import { z } from "zod";

import {
  hrSetupEmployeeRowSchema,
  parseHrSetupPagedBody,
} from "../../hr-setup/schemas/hr-setup-employee.schema.ts";

export const itApprovalEmployeeRowSchema = hrSetupEmployeeRowSchema.extend({
  dob: z.string().nullish(),
  doj: z.string().nullish(),
  joiningDate: z.string().nullish(),
});

export type ItApprovalEmployeeRow = z.infer<typeof itApprovalEmployeeRowSchema>;

/** Parses paginated IT approval list responses with extended employee fields. */
export function parseItApprovalPagedBody(raw: unknown): {
  rows: ItApprovalEmployeeRow[];
  totalPages: number;
  totalElements: number;
} {
  const parsed = parseHrSetupPagedBody(raw);
  const rows = parsed.rows.flatMap((row) => {
    const result = itApprovalEmployeeRowSchema.safeParse(row);
    return result.success ? [result.data] : [];
  });
  return {
    rows,
    totalPages: parsed.totalPages,
    totalElements: parsed.totalElements > 0 ? parsed.totalElements : rows.length,
  };
}
